import React, { useEffect, useRef, useState } from "react";

const EASE = (t) => 1 - Math.pow(1 - t, 3);

/** Counts up to the value — on first paint and again on every change. */
export const CountUp = ({ value, format, duration = 1100, className = "", testid }) => {
  const target = Number(value) || 0;
  const from = useRef(0);
  const [shown, setShown] = useState(0);

  useEffect(() => {
    const start = performance.now();
    const begin = from.current;
    let raf;
    const step = (now) => {
      const t = Math.min(1, (now - start) / duration);
      setShown(begin + (target - begin) * EASE(t));
      if (t < 1) raf = requestAnimationFrame(step);
      else from.current = target;
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [target, duration]);

  return (
    <span className={className} data-testid={testid}>
      {format ? format(shown) : Math.round(shown).toLocaleString("en-US")}
    </span>
  );
};
